import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { KnowledgeBase } from '../models/knowledge-base';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class KnowledgeService {

  public current_knowledge: KnowledgeBase;
  
  private itemDoc: AngularFirestoreDocument<KnowledgeBase>;
  private item: Observable<KnowledgeBase>;

  public spinner: boolean = false;

  constructor(
    private dialog: MatDialog,
    private ff: AngularFireFunctions,
    private db: AngularFirestore,
    private snackBar: SnackBarIconService) { }

  select() {
    return this.db.collection<KnowledgeBase>('sbccv_knowledge', ref => ref.orderBy('name', 'asc')).snapshotChanges();
  }

  selectById(id) {
    this.itemDoc = this.db.doc<KnowledgeBase>('sbccv_knowledge/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert(entity) {
    delete entity.id
    return this.db.collection('sbccv_knowledge').add(Object.assign({}, entity))
  }

  update(entity: KnowledgeBase) {
    let id = entity.id
    delete entity.id
    return this.db.collection('sbccv_knowledge').doc(id).set(Object.assign({}, entity))
  }

  delete(id: any) {
    return this.db.collection('sbccv_knowledge').doc(id).delete();
  }

  makeMsgError(errorCode) {
    
    let msgError: string

    switch (errorCode) {
      case "error code":
        msgError = "error message"
        break;
    }
    
    msgError = errorCode

    return msgError
  }

}

